import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface CTAButtonProps {
  text: string;
  link: string;
  variant?: 'orange' | 'green' | 'apple';
  size?: 'lg' | 'xl';
  className?: string;
  showIcon?: boolean;
  pulse?: boolean;
}
export function CTAButton({
  text,
  link,
  variant = 'orange',
  size = 'lg',
  className = '',
  showIcon = true,
  pulse = false
}: CTAButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center font-bold text-white rounded-full shadow-lg transition-transform hover:scale-105 focus:outline-none focus:ring-4';
  const variants = {
    orange: 'bg-gradient-to-r from-[#FF7B29] to-[#FF9E60] hover:from-[#E56A1F] hover:to-[#FF8C45] focus:ring-orange-300',
    green: 'bg-gradient-to-r from-[#48C579] to-[#6AD493] hover:from-[#3DB068] hover:to-[#5BC282] focus:ring-green-300',
    apple: 'bg-gradient-to-r from-[#7ED321] to-[#A4E157] hover:from-[#6BC211] hover:to-[#8FCC47] focus:ring-lime-300'
  };
  const sizes = {
    lg: 'py-4 px-8 text-lg md:text-xl',
    xl: 'py-5 px-10 text-xl md:text-2xl w-full md:w-auto'
  };
  const pulseAnimation = pulse ? {
    scale: [1, 1.05, 1],
    boxShadow: ['0 10px 15px -3px rgba(126, 211, 33, 0.3)', '0 20px 35px -5px rgba(126, 211, 33, 0.6)', '0 10px 15px -3px rgba(126, 211, 33, 0.3)']
  } : {
    scale: [1, 1.03, 1],
    boxShadow: ['0 10px 15px -3px rgba(0, 0, 0, 0.1)', '0 20px 25px -5px rgba(0, 0, 0, 0.2)', '0 10px 15px -3px rgba(0, 0, 0, 0.1)']
  };
  return <motion.a href={link} target="_blank" rel="noopener noreferrer" className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`} animate={pulseAnimation} transition={{
    duration: pulse ? 1.5 : 2,
    repeat: Infinity,
    repeatType: 'reverse'
  }} whileHover={{
    scale: 1.05
  }} whileTap={{
    scale: 0.98
  }} data-id="element-9">
      <span className="mr-2" data-id="element-10">{text}</span>
      {showIcon && <ArrowRight className="w-6 h-6" data-id="element-11" />}
    </motion.a>;
}